import script from "./ConsumerHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerHomeView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerHomeView.vue?vue&type=style&index=0&id=5c126f14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c126f14"]])

export default __exports__